// extracted by mini-css-extract-plugin
module.exports = {"title":"CouponModal_title__rhFaw","out-of-range-note":"CouponModal_out-of-range-note__N7kHV"};